<template>
	<div class="home-page">
		<!-- vr播放&公司简介 0519new -->
		<section class="home-page-vr-company">
			<div class="home-page-vr" v-if="homeDataItem.isShowVrModal">
				<div class="vr-be-current" @click="openVr(homeDataItem.vRurl)">
				</div>
			</div>
			<div class="home-page-company g_width">
				<div class="left">
					<div class="top">
						<p>COMPANY PROFILE</p>
						<p>{{ homeDataItem.headerTitle }}</p>
					</div>
					<div class="bottom">
						<p class="company-intro">
							{{ homeDataItem.overview }}
						</p>
						<div v-if="false">
							<p class="enterprise-label">
								<span>中国上市公司500强</span>
								<span>同类产品价格最低</span>
								<span>中国建筑照明协会会员单位</span>
								<span>广东省灯具产品价格最低</span>
							</p>
						</div>
					</div>
				</div>
				<div class="right">
					<div class="right_p1">
						<div class="mask">
							<div class="mask-dom"></div>
							<img :src="homeDataItem.vRlogo" alt="">
						</div>
					</div>
					<div class="right_p2"></div>
				</div>
			</div>
		</section>
		<!-- vr播放&公司简介 0519new -->

		<!-- 了解更多 0519new -->
		<section class="home-page-learn-more">
			<div class="learn-more">
				<p>想了解更多关于{{homeDataItem.moreInfoName}}？</p>
				<p>Want to learn more?</p>
			</div>
		</section>
		<!-- 了解更多 0519new -->

		<!-- 公司简介 -->
		<section class="home-page-introduce g_width" v-if="false">
			<h1>企业简介</h1>
			<div class="page-introduce-cont">
				<div class="introduce-info g_d_flex g_flex_justify_space-between g_flex_align_center">
					<div class="page-introduce-cont-left">
						<div class="enterprise-introduce-img" :style="{
							'background-image': `url(${homeDataItem.vRlogo}`,
						}" v-if="homeDataItem.isShowVrModal">
							<div @click="openVr" class="g_d_flex g_flex_align_center g_cursor_pointer"
								v-if="homeDataItem.isShowVr">
								<img src="https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/3D.png" alt="" />
								<span>VR实景1111</span>
							</div>
						</div>
						<video class="enterprise-introduce-video" v-if="homeDataItem.isVideo" controls
							:poster="homeDataItem.videoLogo" :src="homeDataItem.videoUrl"></video>
					</div>
					<div class="g_fontSize_fontWeight page-introduce-cont-right">
						<h2>{{ homeDataItem.headerTitle }}</h2>
						<el-tooltip popper-class="tooltip_default" effect="light" :disabled="true">
							<template #content>
								<div>
									{{ homeDataItem.overview }}
								</div>
							</template>
							<p class="g_multiline_overflow_line_6" style="margin-bottom: 20px">
								{{ homeDataItem.overview }}
							</p>
						</el-tooltip>

						<p class="enterprise-label">
							<span>中国上市公司500强</span>
							<span>同类产品价格最低</span>
							<span>中国建筑照明协会会员单位</span>
							<span>广东省灯具产品价格最低</span>
						</p>
					</div>
				</div>
			</div>
			<div class="home-page-contact">
				<img class="home-page-contact-img" src="https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/contact.png" alt="" />
				<div class="contact" @click="openContactVisible">
					<img src="https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/dianhua-4.png" alt="" />
					联系电话
				</div>
				<div class="contact">
					<img src="https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/goutong.png" alt="" />
					在线沟通
				</div>
			</div>
		</section>

		<!-- 中标次数 -->
		<section class="home-page-enterprise-info-0518">
			<div class="g_width g_d_flex g_flex_justify_space-between">
				<div class="enterprise-info-left">
					<div v-if="biddingList[0]?.num > 0">
						<p>{{ biddingList[0]?.num }}<span>次</span></p>
						<p><span></span><span></span></p>
					</div>

					<div v-if="biddingList[0]?.num == 0" style="display: flex; justify-content: center; align-items: center;">
						<img :src="nodata" alt="">
					</div>


					<div>
						<p>{{ biddingList[1]?.num || 0 }}<span>家</span></p>
						<p><span></span><span></span></p>
					</div>
				</div>
				<div class="enterprise-info-right">
					<div>
						<div class="enterprise-info-right-text g_d_flex g_flex_justify_space-between">
							<p class="details-text-item">
								<i class="label">公司官网：</i><a class="g_hover_color" target="_blank"
									:href="homeDataItem.website">{{ homeDataItem.website
									}}</a>
							</p>
							<p class="details-text-item">
								<i class="label">公司地址：</i>{{ homeDataItem.companyAddress }}
							</p>
						</div>
						<div class="enterprise-info-right-text g_d_flex g_flex_justify_space-between">
							<p class="details-text-item">
								<i class="label">注册资本：</i>{{ homeDataItem.capital }}
							</p>
							<p class="details-text-item">
								<i class="label">成立日期：</i>{{ homeDataItem.establishment }}
							</p>
						</div>
						<div class="enterprise-info-right-text g_d_flex g_flex_justify_space-between">
							<p class="details-text-item">
								<i class="label">经营状态：</i>{{ homeDataItem.operatingStatus }}
							</p>
							<p class="details-text-item">
								<i class="label">经营品牌：</i>{{ homeDataItem.brand }}
							</p>
						</div>
						<div class="enterprise-info-right-text g_d_flex g_flex_justify_space-between">
							<p class="details-text-item">
								<i class="label">经营模式：</i>
								<span class="enterprise-details-text-cont">{{
									homeDataItem.mode
								}}</span>
							</p>
							<p class="details-text-item">
								<i class="label">付款条件：</i>
								<span class="enterprise-details-text-cont">{{
									homeDataItem.paymentTerms
								}}</span>
							</p>
						</div>
						<div class="enterprise-info-right-text g_multiline_overflow">
							<i class="label">供货区域：</i>{{ homeDataItem.supplyArea }}
						</div>
						<div class="enterprise-info-right-text g_multiline_overflow_line_3">
							<i class="label">经营品类：</i><span class="enterprise-details-text-cont">
								{{ homeDataItem.categories }}</span>
						</div>
						<div class="enterprise-info-right-text g_overflow">
							<i class="label">主营产品：</i><span class="enterprise-details-text-cont">
								{{ homeDataItem.mainProducts }}</span>
						</div>
					</div>
					<div class="enterprise-info-plantSize">

						<div>
							<!-- <p>
								<span class="text_orange">{{
									homeDataItem.factoryHeadcount
								}}</span>
								<span>生产基地总数</span>
							</p> -->
							<p>
								<span>生产规模</span>
							</p>
						</div>

						<div>
							<p>
								<span class="text_orange">{{
									homeDataItem.factoryAddress
								}}</span>
								<span>仓储工厂</span>
							</p>
						</div>

						<div>
							<p>
								<span class="text_orange">{{
									homeDataItem.annualOutputValue
								}}</span>
								<span>生产基地总面积</span>
							</p>
						</div>
						<div>
							<p>
								<span class="text_orange">{{
									homeDataItem.capacity
								}}</span>
								<span>单个基地年产量</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- 中标次数 -->

		<!-- 为您推荐 -->
		<section class="home-page-recommended">
			<div class="g_width">
				<!-- 四个以上 -->
				<div class="home-page-recommended-cont" v-if="false">
					<div class="home-page-recommended-left">
						<div class="home-page-recommended-left-img"
							@click="jumpDetail(currentListData.productList[0].name)">
							<img :src="currentListData.productList[0].img" alt="" />
						</div>
						<p class="model">
							{{ currentListData.productList[0].name }}
						</p>
						<p class="text">{{ currentListData.aim }}</p>
						<router-link :to="'/productList?' + `${queryStr}`"
							class="text g_hover_color g_cursor_pointer">了解更多<i>></i></router-link>
					</div>
					<div class="home-page-recommended-right">
						<div class="home-page-recommended-right-img"
							v-for="(item, idx) in currentListData.productList" :key="idx">
							<img @click="jumpDetail(item.name)" :src="item.img" alt="" />
							<p class="g_overflow">{{ item.name }}</p>
						</div>
					</div>
				</div>
				<!-- 四个 -->
				<div class="home-page-recommended-cont">
					<div class="item" v-for="(item, idx) in currentListData.productList.slice(0, 4)" :key="idx">
						<div>
							<span class="view_title">中压电缆</span>
							<span class="view_icon" @click="jumpDetail(item.name)"></span>
							<div class="top">
								<img :src="item.img" alt="">
							</div>
							<div class="bottom">
								<span>{{ item.name }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- 为您推荐 -->


		<!-- 荣誉&资质 -->
		<section class="home-page-enterprise-qualification">
			<div class="g_width enterprise-qualification-cont">
				<div class="enterprise-qualification-bg">
					<!-- 荣誉 -->
					<div class="swiper_all_slide">
						<div class="swiper-button-prev swiper-certificate-prev"></div>
						<div class="swiper-certificate swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(item, idx) in (homeDataItem.certificateList || [])" :key="idx"
									style="width: 170px" @click="openQualificationDialog(item.path)">
									<div class="qualification-carousel-item-img">
										<img :src="item.path" />
									</div>
									<div class="qualification-name">
										<span>{{ item.name }}</span>
									</div>
								</div>
							</div>
							<!-- <div class="swiper-pagination pagination-bottom"></div> -->
						</div>
						<div class="swiper-button-next swiper-certificate-next"></div>
					</div>
					<!-- 资质 -->
					<div class="swiper_all_slide">
						<div class="swiper-button-prev swiper-qualification-prev"></div>
						<div class="swiper-qualification swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(item, idx) in (homeDataItem.qualificationList || [])" :key="idx"
									style="width: 170px" @click="openQualificationDialog(item.path)">
									<div class="qualification-carousel-item-img">
										<img :src="item.path" />
									</div>
									<div class="qualification-name">
										<span>{{ item.name }}</span>
									</div>
								</div>
							</div>
							<!-- <div class="swiper-pagination pagination-bottom"></div> -->
						</div>
						<div class="swiper-button-next swiper-qualification-next"></div>
					</div>

				</div>
				<!-- <div class="ualificationOrHonour">
					<span class="certificate-witching" @click="changeCertificateFlag('荣誉证书')"
						:class="{ active: certificateFlag == '荣誉证书' }">荣誉证书</span>
					<span class="certificate-witching" @click="changeCertificateFlag('资质证书')"
						:class="{ active: certificateFlag == '资质证书' }">资质证书</span>
				</div> -->
			</div>
		</section>

		<!-- 合作伙伴 -->
		<section class="home-page-cooperative" v-if="homeDataItem.cooperativeList && homeDataItem.cooperativeList.length">
			<div class="cooperative_bg">
				<div></div>
			</div>
			<div class="g_width enterprise-cooperative-cont">
				<div class="swiper-cont" v-if="false">
					<div class="swiper-cooperative">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(item, idx) in homeDataItem.cooperativeList"
								:key="idx">
								<div class="cooperative-name">
									<p>{{ item.name }}</p>
									<span>立即查看</span>
								</div>
							</div>
						</div>
						<div class="swiper-pagination"></div>
						<div class="swiper-button-prev swiper-cooperative-prev"></div>
						<div class="swiper-button-next swiper-cooperative-next"></div>
					</div>
				</div>
				<div class="swiper-cooperative-list">
					<div class="swiper-wrapper">
						<div class="swiper-slide swiper-container"
							v-for="(item, idx) in homeDataItem.cooperativeList" :key="idx">
							<div class="cooperative-carousel-item-img">
								<img :src="item.path" />
							</div>

							<div class="cooperative-carousel-item-title">{{ item.name }}</div>

							<div class="swiper-slide-mask" @click="toCase(item.name)">
								<p>{{ item.name }}</p>
								<p>合作案例 ></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<p v-else style="margin: 20px 0"></p>

		<!-- 企业视频 -->
		<section class="home-page-video-cont" v-if="homeDataItem.isVideo">
			<h2>企业视频</h2>
			<video class="home-page-video" v-if="homeDataItem.isVideo" controls
				:poster="homeDataItem.videoLogo" :src="homeDataItem.videoUrl"></video>
		</section>
		<section class="home-page-gold g_width"></section>

		<!-- 为您推荐其他家类似供应商 -->
		<h2 v-if="false" class="g_h2_title g_width">为您推荐其他家类似供应商</h2>
		<section v-if="false" class="home-page-recommend g_d_flex g_flex_justify_space-between g_width">
			<div class="recommend-item" v-for="item in (homeDataItem.recommendList || [])" :key="item.name"
				@click="jumpRecommend(item.jumpParameter)">
				<div class="recommend-item-img">
					<img :src="item.path" alt="" />
				</div>
				<div class="recommend-info">
					<p class="title">{{ item.name }}</p>
					<span class="label">陕建云采高级会员</span>
					<p class="desc g_overflow">
						<span>注册地址：{{ item.site }}</span>
					</p>
					<p class="desc">
						<span>注册资金：{{ item.capital }}</span>
					</p>
					<p class="desc g_overflow">
						<span>主营产品：{{ item.business }}</span>
					</p>
				</div>
			</div>
		</section>
	</div>
	<el-dialog class="certificateDialog g_dialog" v-model="dialogVisible" title="查看" width="600px">
		<img :src="dialogImgUrl" alt="" />
	</el-dialog>
	<el-dialog class="g_herder_bodre_none_dialog contactPersonLoading" v-model="contactVisible" title="" width="460px">
		<h2 class="contactName">
			{{ contactListData.list[0].name }}
			<span v-if="contactListData.list[0].position">
				({{ contactListData.list[0].position }})</span>
		</h2>
		<p class="phoneNum">
			<span>手机：</span>{{
				contactListData.list[0].phoneNum ||
				contactListData.list[0].telephone
			}}
		</p>
	</el-dialog>
</template>

<script setup name="Home">
import { getItem } from "@/plugins/data";
import { ref, reactive, watch, onMounted, nextTick } from "vue";
import { useRouter } from "vue-router";
import Swiper from "swiper"; // 引入库
import "swiper/css/swiper.css";
import nodata from "@/assets/image/nodata.png"
import { getIndex } from "@/plugins/util";

let mySwiper = ref(null);
let cooperativeSwiper = ref(null);
let currentListData = ref(getItem('listData',getIndex()));
let contactListData = ref(getItem('contactListData',getIndex()))
const carouselFn = () => {
	// 荣誉轮播图
	mySwiper = new Swiper(".swiper-qualification", {
		// loop: true,
		navigation: {
			nextEl: ".swiper-qualification-next",
			prevEl: ".swiper-qualification-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			type: "progressbar",
		},
		slidesPerView: 5,
		spaceBetween: 20,
	});

	// 资质轮播图
	new Swiper(".swiper-certificate", {
		// loop: true,
		navigation: {
			nextEl: ".swiper-certificate-next",
			prevEl: ".swiper-certificate-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			type: "progressbar",
		},
		slidesPerView: 5,
		spaceBetween: 20,
	});

	// 合作伙伴轮播图
	cooperativeSwiper = new Swiper(".swiper-cooperative-list", {
		spaceBetween: 0,
		slidesPerView: 5,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
	});

	// new Swiper(".swiper-cooperative", {
	// 	navigation: {
	// 		nextEl: ".swiper-cooperative-next",
	// 		prevEl: ".swiper-cooperative-prev",
	// 	},
	// 	pagination: {
	// 		el: ".swiper-pagination",
	// 		type: "progressbar",
	// 	},
	// 	spaceBetween: 25,
	// 	thumbs: {
	// 		swiper: cooperativeSwiper,
	// 	},
	// });
}

onMounted(async () => {
	await nextTick();
	carouselFn();
});

const router = useRouter();
const enterpriseIndex = ref(getIndex());
let homeDataItem = ref(getItem('homeData',getIndex()) || {});
const biddingList = ref(homeDataItem.value.biddingList || []);
// const certificateFlag = ref("荣誉证书");
const isShow = ref(false);
const unfoldAll = ref(false);
const contactVisible = ref(false);
const dialogVisible = ref(false);
const dialogImgUrl = ref(null);

watch(isShow, (newValue) => {
	if (newValue) {
		unfoldAll.value = true;
	} else {
		unfoldAll.value = false;
	}
});


function openVr(url) {
	window.open(url);  //鼎信
}

//打开荣誉资质证书弹窗
function openQualificationDialog(e) {
	dialogVisible.value = true;
	dialogImgUrl.value = e;
}
//打开联系电话弹窗
function openContactVisible() {
	contactVisible.value = true;
}
//切换供应商
function jumpRecommend(name) {
	router.push({ path: "/home", query: { name } });
	setTimeout(() => {
		window.location.reload();
	});
}

//跳转到详情
function jumpDetail(name) {
	let query = router.currentRoute.value.query || {};
	router.push({ path: "/productDetail", query: { ...query,type: name } });
}


function toCase(name) {
	let query = router.currentRoute.value.query || {};
	router.push({ path: "/case", query: { ...query,type: name } })

}
const queryStr = ref('');
onMounted(() => {
	let query = router.currentRoute.value.query || {};
	let arr = [];
	for(let key in query){
		if(key !== 'type'){
			arr.push(`${key}=${query[key]}`)
		}
	}
    queryStr.value = arr.join('&');

});

</script>

<style lang="scss">
@import "./home.scss"
</style>	